module.exports = __webpack_public_path__ + "img/sig02.752f0b0a.png";